import React, { useEffect, useState } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { addeditdata } from "../../../src/controllers/events/eventsController";
import { fetchIpAddress } from "../../../src/controllers/API";

const EventsEditPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);

  const [passwordVisible, setPasswordVisible] = useState(false);

  // const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    vendor_account_number: ADDEDITDATA?.vendor_account_number || "",
  });
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const {
        _id,
        event_name,
        event_date,
        event_start_time,
        event_end_time,
        event_total_tables,
        event_venue,
        event_location_link,
        event_email_mode
      } = ADDEDITDATA;
      const ipAddress = await fetchIpAddress();

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("name", event_name);
      form.append("date", event_date);
      form.append("start_time", event_start_time);
      form.append("end_time", event_end_time);
      form.append("tables", event_total_tables);
      form.append("venue", event_venue);
      form.append("location_link", event_location_link);
      form.append("event_email_mode", event_email_mode || "test");
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);

      if (isValidate) {
        const options = {
          url: "events/addeditdata",
          postData: form,
        };
        const res = await addeditdata(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated!",
            description: `Data updated successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/events/list");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const numberPattern = /^[0-9]+$/;
    // const vendor_country_code = formData.get("country_code");

    if (!formData.get("name")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        event_name: "Event name is required",
      }));
      return false;
    }
    if (!formData.get("start_time")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        event_start_time: "Start time is required",
      }));
      return false;
    }
    if (!formData.get("end_time")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        event_end_time: "End time is required",
      }));
      return false;
    }
    if (!formData.get("tables")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        event_total_tables: "Number of tables is required",
      }));
      return false;
    }
    if (!formData.get("venue")) {
      setError((prevError) => ({
        ...prevError,
        event_venue: "Please enter venue details",
      }));
      return false;
    }
    return true;
  };

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Events
            </h5>
          </div>
          <Link to="/events/list">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="event_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Name :{" "}
                      </label>
                      <input
                        title="Event Name"
                        placeholder="Enter Event name"
                        type="text"
                        name="event_name"
                        className="form-control store_input_field"
                        id="event_name"
                        value={ADDEDITDATA?.event_name}
                        onChange={handleChange}
                      />
                      {error.event_name ? (
                        <p style={{ color: "red" }}>{error.event_name}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="event_date"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Events Date :{" "}
                      </label>
                      <input
                        title="Enter event date."
                        placeholder="Enter event date."
                        type="date"
                        name="event_date"
                        className="form-control store_input_field"
                        id="event_date"
                        value={ADDEDITDATA?.event_date}
                        onChange={handleChange}
                      />
                      {error.event_date ? (
                        <p style={{ color: "red" }}>{error.event_date}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="event_start_time"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Event start time
                        :{" "}
                      </label>
                      <input
                        title="Enter Event start time."
                        placeholder="Enter Event start time."
                        type="time"
                        name="event_start_time"
                        className="form-control store_input_field"
                        id="event_start_time"
                        value={ADDEDITDATA?.event_start_time}
                        onChange={handleChange}
                      />
                      {error.event_start_time ? (
                        <p style={{ color: "red" }}>{error.event_start_time}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="event_end_time"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Event end time :
                      </label>
                      <input
                        title="Enter Event end time."
                        placeholder="Enter Event end time."
                        type="time"
                        name="event_end_time"
                        className="form-control store_input_field"
                        id="event_end_time"
                        value={ADDEDITDATA?.event_end_time}
                        onChange={handleChange}
                      />
                      {error.event_end_time ? (
                        <p style={{ color: "red" }}>{error.event_end_time}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="event_total_tables"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Tables :
                      </label>
                      <input
                        title="Enter no. of tables"
                        placeholder="Enter no. of tables"
                        type="number"
                        name="event_total_tables"
                        className="form-control store_input_field"
                        id="event_total_tables"
                        min={1}
                        value={ADDEDITDATA?.event_total_tables}
                        onChange={handleChange}
                      />
                      {error.event_total_tables ? (
                        <p style={{ color: "red" }}>
                          {error.event_total_tables}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="event_venue"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Venue :
                      </label>
                      <input
                        title="Enter venue details"
                        placeholder="Enter venue details"
                        type="text"
                        name="event_venue"
                        className="form-control store_input_field"
                        id="event_venue"
                        readOnly={false}
                        value={ADDEDITDATA?.event_venue}
                        onChange={handleChange}
                      />
                      {error.event_venue ? (
                        <p style={{ color: "red" }}>{error.event_venue}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {/* <hr /> */}
                  <div className="row">
                    <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="event_location_link"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Location link :
                      </label>
                      <input
                        title="Enter location link"
                        placeholder="Enter location link"
                        type="text"
                        name="event_location_link"
                        className="form-control store_input_field"
                        id="event_location_link"
                        value={ADDEDITDATA?.event_location_link}
                        onChange={handleChange}
                      />
                      {error.event_location_link ? (
                        <p style={{ color: "red" }}>
                          {error.event_location_link}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="event_email_mode"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Email Mode :
                      </label>
                      <div>
                        <Radio.Group
                          name="event_email_mode"
                          value={ADDEDITDATA?.event_email_mode || "Prod"}
                          onChange={(e) => {
                            setAddEditSata((prev) => ({
                              ...prev,
                              event_email_mode: e.target.value,
                            }));
                            setError((prev) => ({
                              ...prev,
                              event_email_mode: "",
                            }));
                          }}
                        >
                          <Radio value="prod">Prod</Radio>
                          <Radio value="test">Test</Radio>
                        </Radio.Group>
                      </div>
                      {error.event_email_mode ? (
                        <p style={{ color: "red" }}>{error.event_email_mode}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default EventsEditPage;
